import { useState, useEffect } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import { collection, doc, getDoc, getDocs } from "firebase/firestore";
import { db } from "../firebase";
import Banner from "../components/Banner";
import EventDesc from "../components/EventDesc";
import Footer from "../components/Footer";
import Header from "../components/Header";
import {
  applyThemeVarsToElement,
  clearThemeVarsFromElement,
  getEventThemeVars,
} from "../utility/colorUtils";

const EventTicketing = () => {
  const { eventId } = useParams();
  const [searchParams] = useSearchParams();
  const hideLayout = searchParams.get("hideLayout") === "true";
  const [event, setEvent] = useState();
  const [initialTickets, setInitialTickets] = useState(null);
  const [initialTicketsLoadState, setInitialTicketsLoadState] = useState("loading");
  const [style, setStyle] = useState({});
  const [isLoading, setIsLoading] = useState(true);

  const loadEvent = async () => {
    setIsLoading(true);
    setInitialTickets(null);
    setInitialTicketsLoadState("loading");
    const eventRef = doc(db, "Events", eventId);
    const ticketsRef = collection(db, "Events", eventId, "Tickets");
    let loadedEvent;
    let loadedTickets = [];
    let ticketsLoadState = "ready";

    await Promise.all([
      getDoc(eventRef)
        .then((snapshot) => {
          if (!snapshot.exists()) return;
          const data = {
            id: snapshot.id,
            ...snapshot.data(),
          };
          loadedEvent = data;
        })
        .catch((err) => {
          console.log("Fetch event failed: " + err);
        }),
      getDocs(ticketsRef)
        .then((snapshot) => {
          loadedTickets = snapshot.docs.map((doc) => ({
            id: doc.id,
            ...doc.data(),
          }));
        })
        .catch((err) => {
          ticketsLoadState = "error";
          console.log("Fetch tickets failed: " + err);
        }),
    ]);

    setInitialTickets(loadedTickets);
    setInitialTicketsLoadState(ticketsLoadState);

    setStyle(getEventThemeVars(loadedEvent));
    setEvent(loadedEvent);
    setIsLoading(false);
  };

  useEffect(() => {
    if (eventId.length) {
      loadEvent();
    }
  }, [eventId]);

  useEffect(() => {
    if (!event) return undefined;
    applyThemeVarsToElement(document.body, getEventThemeVars(event));
    return () => {
      clearThemeVarsFromElement(document.body);
    };
  }, [event]);

  return (
    <div
      className={`event-ticketing ${event?.darkMode === false ? "light-mode" : ""} ${
        hideLayout ? "is-embedded" : ""
      }`}
      style={style}
    >
      {!hideLayout && <Header logoUrl={event?.logoUrl} isLoading={isLoading} />}
      {!hideLayout && <Banner event={event} hideTitleOverlay />}
      {event && (
        <EventDesc
          event={event}
          initialTickets={initialTickets}
          initialTicketsLoadState={initialTicketsLoadState}
          secretTicketId={searchParams.get("ticketId")}
          isEmbedded={hideLayout}
        />
      )}
      {!hideLayout && (
        <Footer
          logoUrl={event?.logoUrl}
          isDarkMode={event?.darkMode === false ? "light-mode" : ""}
        />
      )}
    </div>
  );
};

export default EventTicketing;
